import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"

import OnboardingSection from "../components/onboarding/onboarding_section"
import { Tutorial } from "../components/tutorial"
import { appStrings } from "../common/strings/app_strings"
import { DESKTOP_LINK } from "../common/constants/app_consts"
import { isElectron } from "../util/electron_ipc"

const { thanks, start, doneMessage } = appStrings.tutorial

class TutorialPage extends React.Component {
    constructor() {
        super()

        this.state = {
            step: 1,
        }
    }
    setStep = step => {
        this.setState({ step })
    }
    skip = () => {
        this.setStep("done")
    }
    finish = () => {
        this.props.handleNavigateAndPatch({})
    }

    render() {
        const isDone = this.state.step === "done"
        // only show this message when we aren't using the electron app
        const showDesktopAppMessage = !isElectron()

        return (
            <OnboardingSection
                sectionTitle={isDone ? thanks : ""}
                buttonValue={isDone ? start : ""}
                onClickAction={isDone ? this.finish : this.skip}
                hasSkipButton={!isDone}
                isXWide={!isDone}
            >
                {isDone ? (
                    <p className="tutorial-done">
                        {doneMessage}
                        <br />
                        {showDesktopAppMessage && (
                            <span>
                                <br />
                                If you have a Mac,{" "}
                                <a href={DESKTOP_LINK} target="_blank">
                                    learn how to install our Desktop app
                                </a>{" "}
                                and get quick access to Shoutbase any time.
                            </span>
                        )}
                    </p>
                ) : (
                    <Tutorial setStep={this.setStep} />
                )}
            </OnboardingSection>
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(TutorialPage)



// WEBPACK FOOTER //
// ./src/pages/tutorial_page.jsx